import { Catalogs } from './icons/Catalogs';
import { PageError } from './icons/PageError';
import { QueryBuilder } from './icons/QueryBuilder';
import { ErrorPageIcon } from './types';

/**
 * getIcon
 * helper function used to display the appropriate icon for a given error page.
 */
export const getIcon = (name?: ErrorPageIcon) => {
  switch (name) {
    case ErrorPageIcon.CatalogCollections:
    case ErrorPageIcon.QueryBuilder:
      return <QueryBuilder />;
    case ErrorPageIcon.Catalogs:
      return <Catalogs />;
    default:
      return <PageError />;
  }
};
